import { NgModule, Input, Output, Directive } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalComponent } from './modal';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [BrowserModule, NgbModule, FormsModule],
  declarations: [NgbdModalComponent],
  exports: [NgbdModalComponent],
  bootstrap: [NgbdModalComponent]
})
export class NgbdModalModule {
  @Input() propertyDecision: string;
  @Input() s: object;
  @Input() loc: Array<any>;

  constructor(

  ) { }

}
